import { IManageMenuItemsState } from "../types";
import { SET_FILTER_STATE, SET_MENU_ITEMS, SET_SELECTED_MENU_ITEMS, SET_FORM_DATA, UPDATE_MENU_POSITION, SET_MENU_TIMING } from "./ManageMenu.actions";


export function ManageMenuReducer(state: IManageMenuItemsState, action: { type: string, payload: any; }) {
    console.log({ action });
    switch (action.type) {
        case SET_FILTER_STATE:
            return {
                ...state,
                filterState: action.payload,
            };

        case SET_MENU_ITEMS:
            return {
                ...state,
                menuLists: action.payload,
            };

        case SET_SELECTED_MENU_ITEMS:
            return {
                ...state,
                selectedMenuItemsList: action.payload,
            };
        case SET_FORM_DATA:
            return {
                ...state,
                menuFormData: action.payload,
            };
        case SET_MENU_TIMING:
            return {
                ...state,
                menuTiming: action.payload,
            };
        case UPDATE_MENU_POSITION:
            const menuItemState = state.menuLists;
            const newPosition = action.payload;
            let index = 0;
            for (const id of newPosition) {
                const productListIndex = menuItemState.findIndex((product) => product.id === id);
                if (productListIndex > -1) {
                    const newItem = {
                        ...menuItemState[productListIndex],
                        sort_position: index
                    }
                    menuItemState[productListIndex] = newItem;
                    index++;
                }
            }
            return {
                ...state,
                menuItemsList: [...menuItemState]
            }


    }
    return state;
}